import { Controller } from "@hotwired/stimulus"

// chat-scroll pins the message list to the bottom on load and when new
// messages append, unless the reader has scrolled up to read history.
export default class extends Controller {
  static values = { readUrl: String, viewerId: Number }

  connect() {
    this.markOwn()
    this.pinned = true
    this.element.scrollTop = this.element.scrollHeight
    this.onScroll = () => this.trackPinned()
    this.element.addEventListener("scroll", this.onScroll)
    this.observer = new MutationObserver(() => {
      this.markOwn()
      this.follow()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
    this.element.removeEventListener("scroll", this.onScroll)
  }

  // trackPinned records whether the reader is at the bottom. The scroll event
  // fires before an append grows scrollHeight, so this captures intent using
  // the pre-mutation geometry, unlike measuring inside follow().
  trackPinned() {
    this.pinned = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight < 120
  }

  // markOwn tags every message the viewer sent with the chat-own class so CSS
  // can restyle it as an own message. Running on connect and on each mutation
  // covers both the initial render and messages that arrive over the stream.
  markOwn() {
    if (!this.hasViewerIdValue) return

    this.element.querySelectorAll(".chat-message[data-sender-id]").forEach((node) => {
      if (Number(node.dataset.senderId) === this.viewerIdValue) node.classList.add("chat-own")
    })
  }

  follow() {
    if (this.pinned) this.element.scrollTop = this.element.scrollHeight
    this.markRead()
  }

  // markRead pings the read endpoint so an open thread clears its unread count
  // as messages arrive. It is a no-op when no read url is configured.
  markRead() {
    if (!this.hasReadUrlValue) return

    fetch(this.readUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content }
    })
  }
}
